"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- PHOTO : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'Photo',
  group: _definitionhelpers.groupNames.graphics,
  props: {
    name: {
      type: 'string',
      default: 'placeholder',
      disabled: true,
      help: {
        title: 'Photo Name',
        desc: "This is where the name of the photo you want to load is written. Currently in the styles only placeholder is supported. For more options of photos, expand the photo_styles.js file.",
        link: {}
      }
    },
    text: {
      type: 'string',
      default: 'Insticator'
    }
  }
};
exports.default = _default;